// Import Actions
import {
  FETCHING_BLOG_PAGE,
  FETCH_BLOG_PAGE,
  FETCHING_BLOG_POST_PAGE,
  FETCH_BLOG_POST_PAGE,
  FETCHING_BLOG_AUTHOR_PAGE,
  FETCH_BLOG_AUTHOR_PAGE,
  FETCHING_BLOG_CATEGORY_PAGE,
  FETCH_BLOG_CATEGORY_PAGE
} from '../actions/BlogActions';

// Initial State
const initialState = {
  blogList: [],
  allPosts:[],
  totalCount: 0,
  pageNum: 1,
  pageSize: 10,
  pageCount: 0,
  isLoadingPage: false,
  isFetchingBlogs: false,
  blogPost: {},
  relatedBlogs:[],
  blogAuthor: {},
  allAuthorPosts: [],
  authorBlogList: [],
  categoryBlogList: []
};

const BlogReducers = (state = initialState, action) => {
  switch (action.type) {

    case FETCHING_BLOG_PAGE:
      return {
        ...state,
        isFetchingBlogs: action.isFetchingBlogs,
      };

    case FETCH_BLOG_PAGE:
      return {
        ...state,
        blogList: action.blogList,
        allPosts: action.allPosts,
        isFetchingBlogs: action.isFetchingBlogs,
        pageNum: action.pageNum,
        pageSize: action.pageSize,
        totalCount: action.totalCount,
        pageCount: action.pageCount,
      };

    case FETCHING_BLOG_POST_PAGE:
      return {
        ...state,
        isLoadingPage: action.isLoadingPage,
      };

    case FETCH_BLOG_POST_PAGE:
      return {
        ...state,
        blogPost: action.blogPost,
        relatedBlogs: action.relatedBlogs,
        isLoadingPage: action.isLoadingPage,
        pageNum: action.pageNum,
        pageSize: action.pageSize,
        totalCount: action.totalCount,
        pageCount: action.pageCount,
      };

    case FETCHING_BLOG_AUTHOR_PAGE:
      return {
        ...state,
        isLoadingPage: action.isLoadingPage,
      };

    case FETCH_BLOG_AUTHOR_PAGE:
      return {
        ...state,
        blogAuthor: action.blogAuthor,
        allAuthorPosts:action.allAuthorPosts,
        isLoadingPage: action.isLoadingPage,
        pageNum: action.pageNum,
        pageSize: action.pageSize,
        totalCount: action.totalCount,
        pageCount: action.pageCount,
        isFetchingBlogs: action.isFetchingBlogs,
        authorBlogList: action.authorBlogList,
      };

    case FETCHING_BLOG_CATEGORY_PAGE:
      return {
        ...state,
        isFetchingBlogs: action.isFetchingBlogs,
      };

    case FETCH_BLOG_CATEGORY_PAGE:
      return {
        ...state,
        categoryBlogList: action.categoryBlogList,
        isFetchingBlogs: action.isFetchingBlogs,
        pageNum: action.pageNum,
        pageSize: action.pageSize,
        totalCount: action.totalCount,
        pageCount: action.pageCount,
      };

    default:
      return state;
  }
};

// Export Reducer
export default BlogReducers;
